import { getRoot, Instance, types } from 'mobx-state-tree';
import { IRootStore } from 'store/root';
import { IProductCmsPc } from '../product-cms';
import { IProductLibrary } from '../product-library';
import BannerStore from './banner';
import ContentCuration from './content-curation';
import MediaStore from './media';
import NewsStore from './news';

export const FeedStore = types
    .model('FeedStore', {
        productId: types.identifier,
        news: types.optional(NewsStore, {}),
        banners: types.optional(BannerStore, {}),
        medias: types.optional(MediaStore, {}),
        contents: types.optional(ContentCuration, {}),
    })
    .views((self) => ({
        get root(): IRootStore {
            return getRoot(self);
        },
    }))
    .views((self) => ({
        get productCmsPc(): IProductCmsPc | undefined {
            return self.root.appStore.pc.find((x) => x.productId === self.productId);
        },
        get productLibrary(): IProductLibrary | undefined {
            return self.root.appStore.library.find((x) => x.productId === self.productId);
        },
        get isMapleM() {
            return ['59789'].includes(self.productId);
        },
    }))
    .actions((self) => ({
        async fetchCDN() {
            self.banners.fetch();
            self.medias.fetch();
            self.news.fetch();
        },
        async fetchServer() {
            if (
                self.productCmsPc?.contentsCuration
                //  && self.contents.state !== 'done'
            ) {
                // content recommendation api requires serviceId from branch
                if (self.productLibrary) {
                    if (!self.productLibrary.currentBranch) await self.productLibrary.fetchBranch();
                } else {
                    if (!self.productCmsPc.publicBranch.branchName) await self.productCmsPc.fetchPublicBranch();
                }
                self.contents.fetchOne();
            }
        },
    }));

export interface IFeedStore extends Instance<typeof FeedStore> {}
